export const API_URL = "https://api.filmwings.com/";
export const MEDIA_API_URL = "https://media.filmwings.com/";
export const WEB_URL = "https://filmwings.com/site/";
//export const API_URL = "http://localhost:3000/api/";
export const API_STATUS = {isLoader:false,isError:false,data:null,total:0,progress:0};
export const FACEBOOK_APP_ID = '933986219669413';